var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer__container"},[_c('v-container',{attrs:{"mt-8":""}},[_c('TheFooterSocials'),_c('TheFooterPartners'),_c('div',{staticClass:"separator"}),_c('v-row',[_c('TheFooterContact'),_c('TheFooterMenu')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }